// The pieces of a document-style report: the ones GPS SENDS to an insurer, as
// opposed to a screen someone happens to print. Styling and the reasoning behind it
// live in src/styles/report-document.css.
//
// Use it like this, with the app's own page heading marked `no-print` because the
// document carries its own title:
//
//   <div className="page-heading no-print"><h2>KPI Report</h2></div>
//   <div className="report-column" style={{ maxWidth: "48rem" }}>
//     <div className="report-doc border rounded">
//       <ReportMasthead title="Results for Vero Insurance" subtitle="June 2026" />
//       <div className="report-body">
//         <ReportBlock title="Service Level Agreement">
//           <ReportFigure label="…" value="87%" working="34 of 39 jobs" />
//         </ReportBlock>
//       </div>
//     </div>
//   </div>

const LOGO = "/images/logo3-clean.png";

// `report` is what the document IS ("KPI Report"), `title` is what this copy of it
// covers ("Results across all companies"). They read as one line, because a client
// opening an emailed PDF should see both at once: which report, and whose numbers.
export function ReportMasthead({ report, title, subtitle, logo = LOGO }) {
  return (
    <header className="report-masthead">
      {logo ? <img className="report-masthead-logo" src={logo} alt="Grayburn Property Services" /> : null}
      <div>
        <div className="report-masthead-title">
          {report ? `${report} : ` : ""}{title}
        </div>
        {subtitle ? <div className="report-masthead-sub">{subtitle}</div> : null}
      </div>
    </header>
  );
}

export function ReportBlock({ title, children }) {
  return (
    <section className="report-block">
      <h3 className="report-block-title">{title}</h3>
      {children}
    </section>
  );
}

// `working` is the population behind the figure ("34 of 39 jobs, target 90%"). It is
// optional in code and close to mandatory in practice: a number that leaves the
// building should be answerable a year later.
export function ReportFigure({ label, value, working, muted = false }) {
  return (
    <div className={`report-figure${muted ? " report-figure-muted" : ""}`}>
      <span className="report-figure-label">{label}</span>
      <span className="report-figure-value">
        <strong>{value}</strong>
        {working ? <div className="report-working">{working}</div> : null}
      </span>
    </div>
  );
}
